import { CopyToClipboard } from 'react-copy-to-clipboard';
import React, { useState } from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import makeStyles from '@mui/styles/makeStyles';
/** import mui components in the section above, Sort Lines Ascending */

const useStyles = makeStyles({
    copyButton: {
        color: '#fff',
        backgroundColor: '#4fc3f7',
        border: '1px solid #4fc3f7',
        cursor: 'pointer',
        borderRadius: 2,
    },
});

/**
 * History Copy button.
 * Copies `textToCopy`, which is the new values only, and shows Copied for two seconds.
 *
 * @param {Object} props
 * @param {string} props.textToDisplay - Idle label, usually Copy.
 * @param {string} props.textToCopy - New values placed on the clipboard.
 * @returns {JSX.Element}
 */
const ClickAndCopyButton = props => {
    const classes = useStyles();
    const { textToDisplay, textToCopy } = props;
    const [isCopied, setIsCopied] = useState(false);
    let buttonLabel = isCopied ? 'Copied' : textToDisplay;

    function destroyCopy() {
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    }

    return (
        <div>
            <CopyToClipboard
                text={textToCopy}
                onCopy={() => {
                    setIsCopied(true);
                }}
            >
                <button
                    className={classes.copyButton}
                    onClick={() => {
                        destroyCopy();
                    }}
                >
                    {isCopied ? <i className={'fa fa-check'} /> : <i className={'fa fa-files-o'} />}
                    &nbsp;
                    {buttonLabel}
                </button>
            </CopyToClipboard>
        </div>
    );
};

export default ClickAndCopyButton;
